import { InjectionToken } from '@angular/core';
// Interfaces
import { IGalleryLightboxData } from '../../../../interfaces/gallery-lightbox-data';

export const GALLERY_LIGHTBOX_DATA = new InjectionToken<IGalleryLightboxData>('GALLERY_LIGHTBOX_DATA');
